/**
 * Page shell matching the marketing site's root layout (ClickUp 86banyvn7):
 * marketing header + footer around the page content, light brand theme.
 * Used by customer-facing pages that must look like legacyorb.com (/account).
 */
import type { ReactNode } from 'react';
import { MarketingHeader } from './MarketingHeader';
import { MarketingFooter } from './MarketingFooter';

export function MarketingChromeLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth-theme flex min-h-screen flex-col bg-background text-foreground antialiased">
      <MarketingHeader />
      <main className="flex-1">{children}</main>
      <MarketingFooter />
    </div>
  );
}
